import { Col as ColBase } from 'antd';
import { ColProps } from 'antd/lib/col';
import React from 'react';

export interface IColProp extends ColProps {
  children?: React.ReactNode;
}

const Col: React.FC<IColProp> = ({ children, ...props }) => {
  return <ColBase {...props}>{children}</ColBase>;
};

export default Col;
